module.exports = __webpack_public_path__ + "img/selected7-min.f4704f1b.png";